import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { HttpClientModule } from "@angular/common/http";

import { SetFocusDirective } from './@tools/set-focus.directive';
import { PatternDirective } from "./@tools/pattern.directive";
import { AdminGuardService } from "./@guards/admin.guard";
import { SocketService } from "./@tools/socket";
import { QueryService } from "./@tools/query";

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AuthComponent } from "./auth/auth.component";
import { RootComponent } from "./root/root.component";
import { RelationComponent } from "./components/table/relation/relation.component";
import { PaginatorComponent } from "./components/paginator/paginator.component";
import { TableComponent } from "./components/table/table.component";
import { MainComponent } from "./main/main.component";
import { DataService } from "./data.service";
import { DatePickerComponent } from './components/date-picker/date-picker.component';
import { DatePickerController } from './components/date-picker/date-picker.service';
import { DatePickerDirective } from './components/date-picker/date-picker.directive';
import { NewsComponent } from './forms/news/news.component';
import { CreateRecordComponent } from './components/create-record/create-record.component';
import { SearchComponent } from './components/search/search.component';


@NgModule({
    declarations: [
        AppComponent,
        MainComponent,
        TableComponent,
        PaginatorComponent,
        PatternDirective,
        RelationComponent,
        RootComponent,
        AuthComponent,
        DatePickerComponent,
        SetFocusDirective,
        DatePickerDirective,
        NewsComponent,
        CreateRecordComponent,
        SearchComponent,
    ],
    imports: [
        CommonModule,
        BrowserModule,
        AppRoutingModule,
        HttpClientModule,
        FormsModule,

        BrowserAnimationsModule,
    ],
    providers: [ QueryService, AdminGuardService, DataService, SocketService, DatePickerController ],
    bootstrap: [ AppComponent ]
})
export class AppModule {
}
